(function() {
  'use strict';

  angular.module('ringbaPortal').directive('disableIvrScroll', disableIvrScroll);

  function disableIvrScroll(

  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      scope: {
        isFilterPopoverShown: '<'
      },
      controller: DisableIvrScrollController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

    function DisableIvrScrollController(

    ) {
      'ngInject';

      const vm = this;
      let $treeCanvasWrapperElement;

      vm.$onInit = onInit;
      vm.$onChanges = onChanges;

      function onInit() {
        $treeCanvasWrapperElement = $('.tree-canvas-wrapper');
      }

      function onChanges() {
        // onChanges is called before onInit when component is initialized
        $treeCanvasWrapperElement = $treeCanvasWrapperElement || $('.tree-canvas-wrapper');

        if (vm.isFilterPopoverShown) {
          _setOverlayPosition();
          $treeCanvasWrapperElement.addClass('disable-scroll overlay-bg');
        } else {
          $treeCanvasWrapperElement.removeClass('disable-scroll overlay-bg');
        }
      }

      function _setOverlayPosition() {
        const ivrPosTop = $treeCanvasWrapperElement.scrollTop(),
          ivrPosLeft = $treeCanvasWrapperElement.scrollLeft();
        $('.overlay').css({
          top: ivrPosTop + 'px',
          left: ivrPosLeft + 'px'
        });
      }
    }
  }

})();
